export default [
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'de-AT',
      href: 'https://www.pfizermedicalinformation.at/de-at',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'de-CH',
      href: 'https://www.pfizermedicalinformation.ch/de-ch',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'de-DE',
      href: 'https://www.pfizermedicalinformation.de/de-de',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'el-GR',
      href: 'https://www.pfizermedicalinformation.gr/el-gr',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-AE',
      href: 'https://www.pfizermedicalinformationgulf.com/en-gulf',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-AFME',
      href: 'https://www.pfizermedicalinformationafrica.com/en-afme',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-AU',
      href: 'https://www.pfizermedicalinformation.com.au/en-au',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-BH',
      href: 'https://www.pfizermedicalinformationgulf.com/en-gulf',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-CA',
      href: 'https://www.pfizermedicalinformation.ca/en-ca',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-DK',
      href: 'https://www.pfizermedicalinformation.dk/en-dk',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-DZ',
      href: 'https://www.pfizermedicalinformation.com.dz/en-dz',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-FI',
      href: 'https://www.pfizermedicalinformation.fi/en-fi',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-FR',
      href: 'https://www.pfizermedicalinformation.fr/en-fr',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-GB',
      href: 'https://www.pfizermedicalinformation.co.uk/en-gb',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-HK',
      href: 'https://www.pfizermedicalinformation.com.hk/en-hk',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-ID',
      href: 'https://www.pfizermedicalinformation.co.id/en-id',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-IE',
      href: 'https://www.pfizermedicalinformation.ie/en-ie',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-IN',
      href: 'https://www.pfizermedicalinformation.in/en-in',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-KW',
      href: 'https://www.pfizermedicalinformationgulf.com/en-gulf',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-NG',
      href: 'https://www.pfizermedicalinformationng.com/en-near',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-NO',
      href: 'https://www.pfizermedicalinformation.no/en-no',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-NZ',
      href: 'https://www.pfizermedicalinformation.co.nz/en-nz',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-OM',
      href: 'https://www.pfizermedicalinformationgulf.com/en-gulf',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-PH',
      href: 'https://www.pfizermedicalinformation.ph/en-ph',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-QA',
      href: 'https://www.pfizermedicalinformationgulf.com/en-gulf',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-SA',
      href: 'https://www.pfizermedicalinformation.sa/en-sa',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-SE',
      href: 'https://www.pfizermedicalinformation.se/en-se',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-TN',
      href: 'https://www.pfizermedicalinformation.com.tn/en-tn',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-US',
      href: 'https://www.pfizermedical.com',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-MY',
      href: 'https://www.pfizermedicalinformation.com.my',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-ZA',
      href: 'https://www.pfizermedicalinformation.co.za/en-za',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-AR',
      href: 'https://www.pfizermedinfo.com.ar/es-ar',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-CL',
      href: 'https://www.pfizermedicalinformation.cl/es-cl',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-CO',
      href: 'https://www.pfizermedicalinformation.com.co/es-co',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-CR',
      href: 'https://www.pfizermedicalinformation.co.cr/es-cr',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-DO',
      href: 'https://www.pfizermedicalinformation.com.do/es-cac',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-EC',
      href: 'https://www.pfizermedicalinformation.ec/es-ec',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-ES',
      href: 'https://www.pfizermedicalinformation.es/es-es',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-GT',
      href: 'https://www.pfizermedicalinformation.com.gt/es-cac',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-HN',
      href: 'https://www.pfizermedicalinformation.hn/es-cac',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-MX',
      href: 'https://www.pfizermedicalinformation.com.mx/es-mx',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-NI',
      href: 'https://www.pfizermedicalinformation.com.ni/es-cac',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-PA',
      href: 'https://www.pfizermedicalinformation.com.pa/es-cac',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-PE',
      href: 'https://www.pfizermedicalinformation.com.pe/es-pe',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-PY',
      href: 'https://www.pfizermedicalinformation.com.py/es-py',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-SV',
      href: 'https://www.pfizermedicalinformation.com.sv/es-cac',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-US',
      href: 'https://www.pfizermedicalinformation.com/es-us',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'es-UY',
      href: 'https://www.pfizermedinfo.com.uy/es-uy',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'en-TR',
      href: 'https://www.pfizermedicalinformation.com.tr',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'fr-AFME',
      href: 'https://www.pfizermedicalinformationafrica.com/fr-afme',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'fr-BE',
      href: 'https://www.pfizermedicalinformation.be/fr-be',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'fr-CA',
      href: 'https://www.pfizermedicalinformation.ca/fr-ca',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'fr-CH',
      href: 'https://www.pfizermedicalinformation.ch/fr-ch',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'fr-DZ',
      href: 'https://www.pfizermedicalinformation.com.dz/fr-dz',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'fr-FR',
      href: 'https://www.pfizermedicalinformation.fr/fr-fr',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'fr-TN',
      href: 'https://www.pfizermedicalinformation.com.tn/fr-tn',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'gb-NIR',
      href: 'https://www.pfizermedicalinformation.co.uk/gb-nir',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'it-IT',
      href: 'https://www.pfizermedicalinformation.it/it-it',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'ja-JP',
      href: 'https://www.pfizermedicalinformation.jp/ja-jp',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'ko-KR',
      href: 'https://www.pfizermedinfo.co.kr/ko-kr',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'nl-BE',
      href: 'https://www.pfizermedicalinformation.be/nl-be',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'nl-NL',
      href: 'https://www.pfizermedicalinformation.nl/nl-nl',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'pt-BR',
      href: 'https://www.pfizermedicalinformation.com.br/pt-br',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'pt-PT',
      href: 'https://www.pfizermedicalinformation.pt/pt-pt',
    },
  },
  {
    tag: 'link',
    attributes: {
      rel: 'alternate',
      hreflang: 'ru-RU',
      href: 'https://www.pfizermedinfo.ru/ru-ru',
    },
  },
];
